import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import { UnusualH1, UnusualH2, UnusualP } from "@/components/unusual/UnusualComponents";
import { UNUSUAL_TEXT_KEY } from "@/components/unusual/constants";
import { spacing } from "@/utils/spacing";
import React from "react";
import styles from "../landing.module.css";
import { LandingHalfSection } from "./styled/Containers";

type SectionContainerProps = {
    title?: string | React.ReactNode;
    subtitle?: React.ReactNode;
    children: React.ReactNode;
    style?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    subtitleStyle?: React.CSSProperties;
    isPageHeader?: boolean;
    sectionStyle?: React.CSSProperties;
    headerStyle?: React.CSSProperties;
    unusualKey?: UNUSUAL_TEXT_KEY;
    unusualAdditional?: string;
};

const SectionContainer = ({
    title,
    subtitle,
    children,
    style,
    unusualKey,
    unusualAdditional,
    titleStyle,
    subtitleStyle,
    isPageHeader = false,
    sectionStyle,
    headerStyle,
}: SectionContainerProps) => {
    const renderTitle = () => {
        return isPageHeader ? (
            <UnusualH1
                className="heading2"
                unusualKey={unusualKey}
                additional={unusualAdditional}
                style={{ maxWidth: "90rem", fontWeight: isPageHeader ? "800" : "600", ...titleStyle }}>
                {title}
            </UnusualH1>
        ) : (
            <UnusualH2
                className="heading2"
                unusualKey={unusualKey}
                additional={unusualAdditional}
                style={{ maxWidth: "90rem", fontWeight: isPageHeader ? "800" : "600", ...titleStyle }}>
                {title}
            </UnusualH2>
        );
    };

    return (
        <LandingHalfSection style={{ maxWidth: "104rem", width: "100%", ...sectionStyle }}>
            <FlexColumnAlignJustifyCenter style={{ width: "100%", gap: spacing.LG_2, ...style }}>
                {!!title && (
                    <FlexColumnAlignJustifyCenter style={{ gap: "1.2rem", textAlign: "center", ...headerStyle }}>
                        {renderTitle()}
                        {subtitle && (
                            <UnusualP
                                className={styles.sectionSubTitle}
                                unusualKey={unusualKey}
                                additional={unusualAdditional}
                                style={{ ...subtitleStyle }}>
                                {subtitle}
                            </UnusualP>
                        )}
                    </FlexColumnAlignJustifyCenter>
                )}
                {children}
            </FlexColumnAlignJustifyCenter>
        </LandingHalfSection>
    );
};

export default SectionContainer;
